// extracted by mini-css-extract-plugin
export default {"loginBannerContainer":"LoginPage_loginBannerContainer__KDjl7","loginBanner":"LoginPage_loginBanner__08fN5"};